import { render, staticRenderFns } from "./CbsWidgetScalarVertical.vue?vue&type=template&id=36b5d913&scoped=true"
import script from "./CbsWidgetScalarVertical.vue?vue&type=script&lang=js"
export * from "./CbsWidgetScalarVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b5d913",
  null
  
)

export default component.exports